var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import Layout from '@/container/Layout';
import { HotlineMeta } from '@/feature/hotline/component/HotlineMeta';
import { useHotlineProListFetch } from '@/feature/hotline/professional/list/hook/useHotlineProListFetch';
import { HotlineProListView } from '@/feature/hotline/professional/list/page/HotlineProListView';
import { canUseHotlineProUser } from '@/feature/hotline/professional/util/canUseHotlineUser';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { pagePath } from '@/utils/router/pagePath';
/**
 * 匿名コンサルホットライン 相談一覧（ロジック部分のみ）
 * @description api データ取得, その他ロジック部分
 */
export const HotlineProListPage = () => {
    const { auth, profile } = useTypeSelector((state) => ({
        auth: state.auth,
        profile: state.profile,
    }));
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    /** ホットライン利用可能なユーザーか */
    const canUseHotline = useMemo(() => canUseHotlineProUser(profile, auth), [auth, profile]);
    // 一覧のデータ取得
    const { fetchListData, isLoading, list } = useHotlineProListFetch({
        dispatch,
        unmountRef,
    });
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield fetchListData();
        }))();
    }, [fetchListData]);
    return (_jsxs(_Fragment, { children: [_jsx(HotlineMeta, { relativePath: pagePath.hotline.professional.list(), title: '匿名ホットライン相談一覧 | PROFFIT' }), _jsx("div", Object.assign({ className: canUseHotline ? '' : 'fixed inset-0' }, { children: _jsx(Layout, Object.assign({ mainClassName: `l-main` }, { children: _jsx(HotlineProListView, { canUseHotline: canUseHotline, isLoading: isLoading, list: list }) })) }))] }));
};
